import { type PropsWithChildren, useState } from "react";
import { Tooltip } from "react-tooltip";
import { CopyIcon } from "vega-icons";

import { Button } from "@vega-core/components/shadcn/button";
import { m } from "@vega-core/paraglide/messages";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { isTruthy } from "@vega-core/utils/isTruthy";

import { type ThemedIconButtonProps } from "../ThemedIconButton";

type Props = Pick<ThemedIconButtonProps, "className"> & {
  btnClassName?: string;
  text: string;
};

export const CopyButton = ({
  btnClassName,
  children,
  className,
  text,
}: PropsWithChildren<Props>) => {
  const [showPopower, setShowPopower] = useState(false);

  const copy = (text: string) => {
    setShowPopower(true);
    navigator.clipboard.writeText(text);
    setTimeout(() => {
      setShowPopower(false);
    }, 1000);
  };

  return (
    <div className="relative">
      <Tooltip
        className="vega-react-tooltip"
        defaultIsOpen={false}
        id="copy-tooltip"
        isOpen={showPopower}
        opacity={1}
        openEvents={{ click: true }}
        place="top"
      />
      <Button
        className={cnTwMerge(
          "rounded-default hover:bg-button/secondary/background/hover",
          btnClassName,
        )}
        data-tooltip-content={m.common_copied()}
        data-tooltip-id="copy-tooltip"
        onClick={() => copy(text)}
        size="icon"
        variant="ghost"
      >
        {isTruthy(children) ? (
          children
        ) : (
          <CopyIcon
            className={cnTwMerge("text-text/primary", className)}
            data-testid="copy-icon"
          />
        )}
      </Button>
    </div>
  );
};
